export default (
  state = {
    show: false,
    content: '',
    type: '',
    pageYOffset: null,
    customizationOpen: false,
  },
  action,
) => {
  switch (action.type) {
    case 'TOGGLE':
      return {
        ...state,
        show: action.value,
      };
    case 'POPULATE_CONTENT':
      return {
        ...state,
        show: action.payload.show,
        content: action.payload.content,
        type: action.payload.type,
        pageYOffset: action.payload.pageYOffset,
      };
    case 'CLOSE_OVERLAY':
      return {
        ...state,
        show: false,
        content: '',
        type: '',
      };
    case 'TOGGLE_CUSTOMIZATION':
      return {
        ...state,
        customizationOpen: action.payload,
      };
    default:
      return state;
  }
};
